<template>
  <div class="GisButton">
    <div class="reset" @click="resetFn"></div>
    <div
      class="rotate"
      @click="rotateFn"
      :class="cameraRotate ? 'rotate_ac' : ''"
    ></div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CameraList from '../../utils/configs/cameraList';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['cameraRotate']),
  },
  methods: {
    resetFn(item) {
      setTimeout(() => {
        this.$store.commit('setCameraRotate', false);
      }, 1500);
      window.appInstance.uniCall(
        'setCamera',
        CameraList[this.$store.state.cameraInfo]
      );
    },
    rotateFn() {
      this.$store.commit('setCameraRotate', !this.cameraRotate);
    },
  },
};
</script>

<style lang="less" scoped>
.GisButton {
  display: flex;
  pointer-events: all;
  .reset {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    background: url(../../assets/img/commonComponents/positionme.png) no-repeat
      center center;
    &:hover {
      background: url(../../assets/img/commonComponents/positionmehover.png)
        no-repeat center center;
    }
  }
  .rotate {
    width: 40px;
    height: 40px;
    background: url(../../assets/img/commonComponents/resovet.png) no-repeat
      center center;
    &:hover {
      background: url(../../assets/img/commonComponents/resovet_hover.png)
        no-repeat center center;
    }
  }
  .rotate_ac {
    background: url(../../assets/img/commonComponents/resovet_click.png)
      no-repeat center center;
  }
}
</style>
